import type { SupabaseClient } from "@supabase/supabase-js";

import { MFA_SETUP_PATH } from "./constants";
import { getMfaRedirect, type MfaFactors } from "./mfaAuthGuard";
import { validateTrustedDevice } from "./trustedDevice";

export async function evaluateMfaAuthState(
  supabase: SupabaseClient,
  pathname: string,
): Promise<{ redirectTo: string } | null> {
  const [{ data: aalData, error: aalError }, { data: factorsData, error: factorsError }] =
    await Promise.all([
      supabase.auth.mfa.getAuthenticatorAssuranceLevel(),
      supabase.auth.mfa.listFactors(),
    ]);

  if (aalError || factorsError) {
    return { redirectTo: MFA_SETUP_PATH };
  }

  const factors: MfaFactors = {
    totp: factorsData?.totp ?? [],
    phone: factorsData?.phone ?? [],
  };

  const isTrustedDevice = await validateTrustedDevice();

  const redirectTo = getMfaRedirect({
    currentLevel: aalData?.currentLevel ?? null,
    nextLevel: aalData?.nextLevel ?? null,
    factors,
    isTrustedDevice,
    pathname,
  });

  if (redirectTo) {
    return { redirectTo };
  }

  return null;
}
